import {PageFragment, PageFragmentProps, PageFragmentState} from "shared/PageFragment";
import {Box, IconButton, Tooltip} from "@mui/material";
import {colorHighlightAlt, darkGray, lightGray} from "shared/colors";
import React, {Suspense} from "react";
import {SZ_SM} from "shared/dimens";
// import {ReactComponent as View3dOutlined} from "res/images/scan3d/ic_view3d.svg";
// import {ReactComponent as ViewFrontOutlined} from "res/images/scan3d/ic_viewfront.svg";
// import {ReactComponent as ViewTopOutlined} from "res/images/scan3d/ic_viewtop.svg";
// import {ReactComponent as ViewLeftOutlined} from "res/images/scan3d/ic_viewleft.svg";
// import {ReactComponent as ViewRightOutlined} from "res/images/scan3d/ic_viewright.svg";
import {Action} from "shared/types";
import {ViewScene, ViewSceneType} from "../ViewScene";
// import {createIcon} from "@/shared/icons";
import {CameraPreset} from "../types";

export type StlViewFragmentProps = PageFragmentProps & {
  sceneUrl?: string,
}

export type StlViewFragmentState = PageFragmentState & {
  sceneCameraPreset?: CameraPreset,
}

export class StlViewFragment extends PageFragment<StlViewFragmentProps, StlViewFragmentState> {

  private readonly background = "linear-gradient(" + [lightGray, colorHighlightAlt].join(",") + ")";
  private readonly viewActions: Action[] = [
    // new Action("3D", event => {
    //   this.setState({
    //     sceneCameraPreset: CameraPreset.DEFAULT,
    //   });
    // }, createIcon(<View3dOutlined/>)),
    // new Action("Front", event => {
    //   this.setState({
    //     sceneCameraPreset: CameraPreset.FRONT,
    //   });
    // }, createIcon(<ViewFrontOutlined/>)),
    // new Action("Top", event => {
    //   this.setState({
    //     sceneCameraPreset: CameraPreset.TOP,
    //   });
    // }, createIcon(<ViewTopOutlined/>)),
    // new Action("Left", event => {
    //   this.setState({
    //     sceneCameraPreset: CameraPreset.LEFT,
    //   });
    // }, createIcon(<ViewLeftOutlined/>)),
    // new Action("Right", event => {
    //   this.setState({
    //     sceneCameraPreset: CameraPreset.RIGHT,
    //   });
    // }, createIcon(<ViewRightOutlined/>)),
  ];

  renderContent(): React.ReactElement {
    return <Box style={{display: "flex", flexGrow: 1, position: "relative", background: this.background}}>
      <Suspense fallback={"Please wait..."}>
        {this.props.sceneUrl ?
          <ViewScene
            url={this.props.sceneUrl}
            type={ViewSceneType.STL}
            cameraPreset={this.state.sceneCameraPreset}/>
          : null}
      </Suspense>
      {this.renderViewActions()}
    </Box>
  }

  private renderViewActions() {
    return <Box style={{
      display: "flex",
      position: "absolute",
      bottom: 0,
      right: 0,
      zIndex: 1200,
      width: "100%",
      height: SZ_SM,
      justifyContent: "flex-end",
      alignItems: "center"
    }}>
      {this.viewActions.map(action => this.renderViewButton(action))}
    </Box>;
  }

  private renderViewButton(action: Action) {
    const IconType = action.iconType;
    return <Tooltip arrow title={action.text}>
      <IconButton style={{marginLeft: -8, width: SZ_SM, height: SZ_SM}} onClick={(event) => action.onClick(event)}>
        <IconType style={{fill: darkGray}} viewBox="0 0 24 24"/>
      </IconButton>
    </Tooltip>;
  }
}
